import { LetterHeadTable } from "@/components/agendaTemplate/LetterheadTable";
import { PageHeader } from "@/components/page";
import { useRoleProtected } from "@/hooks/useRoleProtected";
import { AppUrlPath } from "@/lib/AppUrlPath";
import { useUserStore } from "@/stores/userStore";
import { DataTableWrapper } from "@repo/ui/components/Base/DataTable";
import { Tooltip } from "@repo/ui/components/Base/Tooltip";
import { useNavigate, useParams } from "react-router-dom";
import { CreateTriggerButton } from "@repo/ui/components/Base/CreateTriggerButton";
import { useGetTenantByFriendly } from "@/hooks/queryHooks/tenantHooks";

export const LetterHeadsPage = () => {
  useRoleProtected("admin");
  const { tenantId } = useParams();
  const { data: tenantData } = useGetTenantByFriendly(tenantId ?? "");
  const activeTeam = useUserStore((s) => s.activeTeam);

  const navigate = useNavigate();

  if (!tenantId || !tenantData) return null;

  const isFullOrg = activeTeam === "org";

  return (
    <div className="flex flex-col flex-grow">
      <PageHeader
        title={
          tenantData.name ? `${tenantData.name}'s Letterheads` : "Letterheads"
        }
      >
        {activeTeam === "org" && (
          <p className="text-red-500 w-0 flex-grow-[3] mr-8 text-balance text-right">
            You must select a team to be able to edit and create letterheads.
          </p>
        )}
        <Tooltip
          asChild
          label={
            isFullOrg
              ? "Select a team to create a letterhead"
              : "Create a Letterhead"
          }
          tooltipTriggerProps={{ disabled: isFullOrg }}
        >
          <CreateTriggerButton
            onClick={() => {
              navigate(new AppUrlPath(tenantId).getLetterHeadPath("create"));
            }}
          />
        </Tooltip>
      </PageHeader>
      <DataTableWrapper>
        <LetterHeadTable tenantId={tenantData.id} />
      </DataTableWrapper>
    </div>
  );
};
